import { IkeFieldType } from '@ikegps/core-api';
import { FormModelField } from '../../form.field';
import { FormModelFieldSelectList } from '../../form.select.list';
import { IPFSpanType, SPAN_TYPES, SpanType } from '../../../pole/integrations';
import { FormModelFieldSubForm, FormModelMutatorSubForm } from '../form.subform';

const spanTypeOptions = {
	foreSpan: [
		IPFSpanType.FORE_SPAN, // IPF
		SpanType.NextPole, // DDS, OCalc, PoleForeman Legacy, Spida
	],
	backSpan: [
		IPFSpanType.BACK_SPAN, // IPF
		SpanType.PreviousPole, // DDS, OCalc, PoleForeman Legacy, Spida
	],
	otherSpan: [
		IPFSpanType.OTHER, // IPF
		SpanType.Other, // DDS, OCalc, PoleForeman Legacy, Spida
	],
	buildingSpan: [
		SpanType.Building, // DDS, OCalc, PoleForeman Legacy, Spida
	],
} as const;

export function isValidSpanVectorField(field: FormModelField): boolean {
	return field.type === IkeFieldType.VECTOR;
}

export function isValidSpanTypeField(field: FormModelField): boolean {
	if (!FormModelFieldSelectList.isSelectList(field)) {
		return false;
	}
	// Must include a valid Fore Span option.
	if (!field.options.some((option) => spanTypeOptions.foreSpan.find((valid) => valid === option.value))) {
		return false;
	}
	// Must include a valid Back Span option.
	if (!field.options.some((option) => spanTypeOptions.backSpan.find((valid) => valid === option.value))) {
		return false;
	}
	// Must include a valid Other Span option.
	if (!field.options.some((option) => spanTypeOptions.otherSpan.find((valid) => valid === option.value))) {
		return false;
	}
	return true;
}

export function createSpanTypeField(mut: FormModelMutatorSubForm) {
	const selectList = mut.create<FormModelFieldSelectList>('selectlist');

	selectList.Mutator.option({ text: SPAN_TYPES[0].name, value: SPAN_TYPES[0].type }); // NEXT_POLE
	selectList.Mutator.option({ text: SPAN_TYPES[1].name, value: SPAN_TYPES[1].type }); // PREVIOUS_POLE
	selectList.Mutator.option({ text: SPAN_TYPES[2].name, value: SPAN_TYPES[2].type }); // OTHER_POLE
	selectList.Mutator.option({ text: SPAN_TYPES[3].name, value: SPAN_TYPES[3].type }); // BUILDING

	return selectList;
}

/**
 * Validates that a field can be used as a mid span IKE photo field.
 * Must be a TRUE_SIZE field type which stores CaptureFileJSONObject[].
 */
export function isValidMidSpanIkePhotoField(field: FormModelField): boolean {
	return field.type === IkeFieldType.TRUE_SIZE;
}

/**
 * Check if a span subform has complete type state for two-way linking.
 * Returns true if all required fields (vector, type, midSpanPhoto) are configured.
 *
 * @param schema The subform field to check
 * @returns true if the span has complete configuration for two-way linking
 */
export function hasCompleteSpanTypeState(schema: FormModelFieldSubForm): boolean {
	const state = schema.subFormSpanTypeState;
	if (!state) return false;
	return !!(state.vectorFieldId && state.typeFieldId && state.midSpanIkePhotoFieldId);
}
